import { ensureError } from '@repo/utils'

import { errorReporter } from './error-reporter'

/** Captures an error to Sentry. Accepts `unknown` and coerces non-Error values internally. */
export function captureError(error: unknown, extra?: Record<string, unknown>): void {
  errorReporter.captureException(ensureError(error), extra)
}
